import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Tag, message, Modal } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import questionService from '../services/question';
import tagService from '../services/tag';

const QuestionList = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [questionTypes, setQuestionTypes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchQuestions();
    fetchTags();
    fetchQuestionTypes();
  }, []);

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const response = await questionService.getQuestions();
      setQuestions(response.data);
    } catch (error) {
      message.error('获取题目列表失败');
    }
    setLoading(false);
  };

  const fetchTags = async () => {
    try {
      const response = await tagService.getTags();
      console.log('获取标签列表成功:', response);
      if (response && response.data && Array.isArray(response.data.items)) {
        console.log('使用response.data.items作为数据');
        setTags(response.data.items);
      } else if (response && Array.isArray(response.data)) {
        console.log('使用response.data作为数据');
        setTags(response.data);
      } else if (Array.isArray(response)) {
        console.log('直接使用response作为数据');
        setTags(response);
      } else {
        console.log('数据格式不正确，设置为空数组');
        setTags([]);
      }
    } catch (error) {
      console.error('获取标签列表失败:', error);
      message.error('获取标签列表失败');
      setTags([]);
    }
  };

  const fetchQuestionTypes = async () => {
    try {
      const response = await questionService.getQuestionTypes();
      console.log('获取题目类型成功:', response);
      if (response && response.data && Array.isArray(response.data.items)) {
        console.log('使用response.data.items作为数据');
        setQuestionTypes(response.data.items);
      } else if (response && Array.isArray(response.data)) {
        console.log('使用response.data作为数据');
        setQuestionTypes(response.data);
      } else if (Array.isArray(response)) {
        console.log('直接使用response作为数据');
        setQuestionTypes(response);
      } else {
        console.log('数据格式不正确，设置为空数组');
        setQuestionTypes([]);
      }
    } catch (error) {
      console.error('获取题目类型失败:', error);
      message.error('获取题目类型失败');
      setQuestionTypes([]);
    }
  };

  const handleAdd = () => {
    navigate('/questions/create');
  };

  const handleEdit = (record) => {
    navigate(`/questions/edit/${record.id}`);
  };

  const handleDelete = async (record) => {
    Modal.confirm({
      title: '确认删除',
      content: '确定要删除这道题目吗？',
      onOk: async () => {
        try {
          await questionService.deleteQuestion(record.id);
          message.success('删除成功');
          fetchQuestions();
        } catch (error) {
          message.error('删除失败');
        }
      },
    });
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '题目类型',
      dataIndex: ['type', 'type_name'],
      key: 'type',
    },
    {
      title: '题目内容',
      dataIndex: 'content',
      key: 'content',
      ellipsis: true,
    },
    {
      title: '难度',
      dataIndex: 'difficulty',
      key: 'difficulty',
      render: (difficulty) => {
        const colors = ['green', 'blue', 'orange', 'red', 'purple'];
        return <Tag color={colors[difficulty - 1]}>{difficulty}</Tag>;
      },
    },
    {
      title: '标签',
      dataIndex: 'tags',
      key: 'tags',
      render: (tags) => (
        <Space>
          {tags.map((tag) => (
            <Tag key={tag.id}>{tag.tag_name}</Tag>
          ))}
        </Space>
      ),
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          >
            编辑
          </Button>
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record)}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
          添加题目
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={questions}
        rowKey="id"
        loading={loading}
      />
    </div>
  );
};

export default QuestionList; 